export default __webpack_public_path__ + "assets/front/scss/editorial.5ee5cc731d0b9eeb48e3b194af93c308.css";